<template>
    <div class="filter-bar" :class="{ 'filter-bar--collapsed': collapsed }">

        <b-button v-if="collapsed"
                  :variant="activeCount ? 'primary' : 'outline-secondary'"
                  class="filter-bar__toggle"
                  @click="open = !open">
            <feather-icon icon="FilterIcon" class="mr-5"></feather-icon>
            {{ label }}
            <b-badge v-if="activeCount" variant="light" class="ml-5">{{ activeCount }}</b-badge>
            <feather-icon :icon="open ? 'ChevronUpIcon' : 'ChevronDownIcon'" class="ml-5"></feather-icon>
        </b-button>

        <b-collapse :visible="!collapsed || open" class="filter-bar__collapse">
            <div class="filter-bar__body">
                <slot></slot>
                <div v-if="$slots.actions" class="filter-bar__actions">
                    <slot name="actions"></slot>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    /*
     * Wraps a strip of filter controls. Inline (flex-wrap) on desktop; collapsible
     * behind a "Filtre" button on tablets/phones, with each control stretched full width.
     */
    export default {
        props: {
            collapsible: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default: 'Filtre'
            },
            activeCount: {
                type: Number,
                default: 0
            },
            // breakpoint below which the bar collapses: 'md' (< 768) or 'lg' (< 992)
            collapseBelow: {
                type: String,
                default: 'lg'
            }
        },
        data: () => ({
            open: false
        }),
        computed: {
            collapsed() {
                if (!this.collapsible) {
                    return false
                }
                return this.collapseBelow === 'md' ? this.isMobile : this.isTablet
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar {
        min-width: 0;
    }

    .filter-bar__body {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .filter-bar__actions {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .filter-bar--collapsed {
        width: 100%;

        .filter-bar__toggle {
            min-height: 44px;
        }

        .filter-bar__body {
            flex-direction: column;
            align-items: stretch;
            padding-top: 10px;

            ::v-deep > * {
                width: 100% !important;
                max-width: 100% !important;
                min-width: 0 !important;
            }

            ::v-deep .v-select {
                min-width: 0;
                width: 100%;
            }

            ::v-deep .btn {
                min-height: 44px;
            }
        }

        .filter-bar__actions {
            justify-content: stretch;

            ::v-deep > * {
                flex: 1 1 auto;
            }
        }
    }
</style>
